import AboutApplia from "../../../assets/images/content/introduction/about-applia/about-applia-mobile.svg";
import PaoloFalcioni from "../../../assets/images/content/introduction/foreword/paolo_falcioni.jpg";
import ReinhardZinkann from "../../../assets/images/content/introduction/foreword/reinhard-zinkann.jpg";
import Policy6 from "../../../assets/images/content/introduction/executive-summary/pool.webp";
import Policy8 from "../../../assets/images/content/introduction/executive-summary/factory.webp";

import NationalAssociationsDesktop from "../../../assets/images/content/introduction/applia-members/map-national-associations-desktop.svg";
import NationalAssociationsMobile from "../../../assets/images/content/introduction/applia-members/map-national-associations-mobile.svg";
import IRHMADesktop from "../../../assets/images/content/introduction/irhma/irhma-desktop.png";
import IRHMAMobile from "../../../assets/images/content/introduction/irhma/irhma-mobile.png";
import ProductsDesktop from "../../../assets/images/content/introduction/products/products-desktop-2.png";
import ProductsMobile from "../../../assets/images/content/introduction/products/products-mobile-2.png";

import IconPolicy from "../../../assets/images/content/introduction/applia-members/icon-policy.svg";
import IconMarketIntelligence from "../../../assets/images/content/introduction/applia-members/icon-market-intelligence.svg";
import IconHandshake from "../../../assets/images/content/introduction/applia-members/icon-handshake.svg";
import IconEvents from "../../../assets/images/content/introduction/applia-members/icon-events.svg";

import IconFactory from "../../../assets/images/content/introduction/home-appliance-industry/icon-factory.svg";
import IconWorkers from "../../../assets/images/content/introduction/home-appliance-industry/icon-workers.svg";
import IconEuros from "../../../assets/images/content/introduction/home-appliance-industry/icon-euros.svg";
import IconEurope from "../../../assets/images/content/introduction/home-appliance-industry/icon-europe.svg";
import IconTrolley from "../../../assets/images/content/introduction/home-appliance-industry/icon-trolley.svg";
import IconCustomer from "../../../assets/images/content/introduction/home-appliance-industry/icon-customer.svg";
import IconSaveEnergy from "../../../assets/images/content/introduction/home-appliance-industry/icon-save-energy.svg";
import IconBattery from "../../../assets/images/content/introduction/home-appliance-industry/icon-battery.svg";
import IconIdea from "../../../assets/images/content/introduction/home-appliance-industry/icon-idea.svg";
import IconSolution from "../../../assets/images/content/introduction/home-appliance-industry/icon-solution.svg";

import { directMembers } from "../../../assets/data/content/introduction/direct-members/data";
import { associateMembers } from "../../../assets/data/content/introduction/associate-members/data";
import { IRHMAImages } from "../../../assets/data/content/introduction/irhma/data";

import { PageContent } from "./types";

export const introductionContent: Record<string, PageContent> = {
	"/introduction/foreword": {
		blocks: [
			{
				type: "text-image",
				id: "foreword-reinhard-zinkann",
				data: {
					text: [
						"Global economic uncertainty, geopolitical tensions and competing short-term priorities are reshaping industries worldwide — at a time when the urgency of climate action risks receiving less public and political attention. The current global energy context underlines that Europe faces a defining challenge: to maintain industrial leadership while advancing a clean, competitive and fair transition.", "For the home appliance sector, efficiency, resilience and sustainability are central to this ambition. These are not new priorities, but long-standing principles that continue to shape how products are designed and manufactured.", "Across Europe, our industry continues to innovate by delivering technologies that enhance energy and water efficiency, increasingly integrating connectivity and digital solutions. Our appliances are evolving into integral components of a more responsive energy system, helping households manage their consumption more effectively.","For industry to keep delivering, Europe needs the right conditions: a stable and predictable regulatory framework, a strong Single Market and a level playing field for all actors.","The 10th edition of the <em>Home Appliance Monitor</em> offers a comprehensive overview of our sector’s performance and its vital role in advancing Europe’s energy and sustainability objectives, while also outlining the necessary conditions to ensure continued progress in the future.",
					],
					title: "Reinhard Zinkann",
					subtitle: "- APPLiA President & Executive Director and Co-Proprietor of Miele Group",
					type: "image-left-column",
					imageAlt: "Reinhard Zinkann - APPLiA President & Executive Director and Co-Proprietor of Miele Group",
					imageUrl: ReinhardZinkann,
					imageSize: "small",
					imageAccent: "nameplate",
				},
			},
			{
				type: "pull-quote",
				id: "foreword-reinhard-zinkann-quote",
				data: {
					text: "Europe faces a defining challenge: to maintain industrial leadership while advancing a clean, competitive and fair transition.",
					attribution: "Reinhard Zinkann, APPLiA President",
				},
			},
			{
				type: "divider",
				id: "foreword-divider",
			},
			{
				type: "text-image",
				id: "foreword-paolo-falcioni",
				data: {
					text: [
						"The figures in this report tell the story of an industry that remains a strong part of Europe’s economy and a familiar presence in people’s homes. Home appliances are used every day by millions of households, but behind them stands a sector that also supports jobs, drives innovation, and maintains an important manufacturing base across Europe.","This 10th edition of the <em>Home Appliance Monitor</em> shows how the industry continues to evolve. Appliances are becoming more efficient, more connected, and increasingly integrated into the way households manage energy and resources. At the same time, manufacturers are navigating a more demanding environment, shaped by changing markets, new technologies, and growing pressure on Europe’s industrial competitiveness.","The report brings these developments together and offers a clear view of where the sector stands today: an industry that continues to deliver for consumers and for Europe, while preparing for the next phase of its transformation.",
					],
					title: "Paolo Falcioni",
					subtitle: "- APPLiA Director General",
					type: "image-left-column",
					imageAlt: "Paolo Falcioni - APPLiA Director General",
					imageUrl: PaoloFalcioni,
					imageSize: "small",
					imageAccent: "nameplate",
				},
			},
			{
				type: "pull-quote",
				id: "foreword-paolo-falcioni-quote",
				data: {
					text: "Appliances are becoming more efficient, more connected, and increasingly integrated into the way households manage energy and resources.",
					attribution: "Paolo Falcioni, APPLiA Director General",
				},
			},
		],
	},
	"/introduction/about-applia": {
		blocks: [
			{
				id: "aboutApplia-intro",
				type: "text-image",
				data: {
					text: [
						"APPLiA - Home Appliance Europe is the voice of Europe’s home appliance manufacturers.",
						"We cover a wide range of products within our scope including fridges, dishwashers, washing machines, ovens, vacuum cleaners, heating, ventilation and air conditioning equipment, among others, and for residential use only.",
						"We advocate for a regulatory environment that encourages innovation, sustainability, and energy efficiency, enabling manufacturers to develop cutting-edge products for all European consumers.",
						"Together with our members and national associations, we develop industry policy positions on key legislative issues and help shape relevant EU policies.",
					],
					type: "image-right",
					imageAlt: "APPLiA – Home Appliance Europe logo",
					imageUrl: AboutApplia,
					imageSize: "big",
				},
			},
		],
	},
	"/introduction/applia-members": {
		blocks: [
			{
				id: "applia-members-intro",
				type: "text",
				data: {
					text: ["APPLiA brings together a total of <strong>57 members</strong>, including <strong>25 Direct Members</strong>, <strong>4 Associate Members</strong>, and <strong>28 National Associations</strong> across Europe.","All members are committed to APPLiA’s statutes, by-laws, and industry agreements, including the Code of Conduct on Corporate Social Responsibility, promoting high standards in working conditions, social compliance, and environmental performance across the sector."],
				},
			},
			{
				id: "applia-members-direct-title",
				type: "header",
				data: {
					text: "Direct Members",
					type: "h3",
				},
			},
			{
				id: "applia-members-direct-intro",
				type: "text",
				data: {
					text: ["<strong>Direct Members</strong> are companies with at least one manufacturing facility in Europe and a direct presence in multiple European markets. They represent the core of the European home appliance industry, combining manufacturing, innovation, and market reach.",
					],
				},
			},
			{
				id: "applia-members-direct-logos",
				type: "image-grid",
				data: {
					cols: 5,
					responsiveCols: {
						xs: 2,
						sm: 3,
						md: 4,
						lg: 5,
					},
					items: directMembers,
				},
			},
			{
				id: "applia-members-associate-title",
				type: "header",
				data: {
					text: "Associate Members",
					type: "h3",
				},
			},
			{
				id: "applia-members-associate-intro",
				type: "text",
				data: {
					text: "<strong>Associate Members</strong> contribute specialised expertise and support the sector’s development through their involvement in the broader value chain.",
				},
			},
			{
				id: "applia-members-associate-logos",
				type: "image-grid",
				data: {
					cols: 5,
					responsiveCols: {
						xs: 2,
						sm: 3,
						md: 4,
						lg: 5,
					},
					items: associateMembers,
				},
			},
			{
				id: "applia-members-national-title",
				type: "header",
				data: {
					text: "National Associations",
					type: "h3",
				},
			},
			{
				id: "applia-members-national-intro",
				type: "text",
				data: {
					text: "<strong>National Associations</strong> ensure strong representation at country level, connecting European priorities with national contexts and supporting the effective implementation of industry initiatives across markets.",
				},
			},
			{
				id: "applia-members-national-map",
				type: "responsive-image",
				data: {
					desktopImageUrl: NationalAssociationsDesktop,
					mobileImageUrl: NationalAssociationsMobile,
					containerClassName: "-mx-6 md:-mx-9 xl:-mx-14",
				},
			},
			{
				id: "applia-members-become-title",
				type: "header",
				data: {
					text: "Become a member",
					type: "h3",
				},
			},
			{
				id: "applia-members-become-intro",
				type: "text",
				data: {
					text: [
						"Are you an home appliance manufacturer? Join APPLiA and stay ahead of the latest EU policy developments while ensuring your voice is heard in EU institutions.",
						"With almost 70 years of experience, APPLiA is the <strong>leading trade association</strong> dedicated to supporting and growing the home appliance industry in Europe."
					],
				},
			},
			{
				id: "applia-members-become-icons",
				type: "image-grid",
				data: {
					cols: 4,
					responsiveCols: {
						xs: 2,
						md: 4,
					},
					imageClassName: "w-24 h-24",
					items: [
						{
							id: "become-icon-policy",
							imageUrl: IconPolicy,
							imageAlt: "Policy influence",
							text: "Policy influence",
						},
						{
							id: "become-icon-market-intelligence",
							imageUrl: IconMarketIntelligence,
							imageAlt: "Market intelligence",
							text: "Market intelligence",
						},
						{
							id: "become-icon-handshake",
							imageUrl: IconHandshake,
							imageAlt: "Networking & business opportunities",
							text: "Networking & business opportunities",
						},
						{
							id: "become-icon-events",
							imageUrl: IconEvents,
							imageAlt: "Events & brand exposure",
							text: "Events & brand exposure",
						},
					],
				},
			},
		],
	},
	"/introduction/global-collaboration": {
		blocks: [
			{
				id: "irhma-introduction",
				type: "text",
				data: {
					text: [
						"The <strong>International Roundtable of Household Appliance Manufacturer Associations (IRHMA)</strong> was founded in 2014. The roundtable gathers experts from the EU, Russia, US & Canada, Korea, China, Japan, India, Mexico, South Africa & Australia, ensuring nearly global coverage of the household appliance sector.","Members convene annually to discuss the most pressing issues facing the industry and to exchange valuable knowledge and insights. This informal forum allows stakeholders to collaboratively address global challenges and strengthen the sector.","For more information or to join, visit: <a target=\"_blank\" rel=\"noreferrer\" class=\"text-primary underline\" href=\"https://www.irhma.org\">irhma.org</a>",
					],
				},
			},
			{
				type: "responsive-image",
				id: "irhma-map",
				data: {
					desktopImageUrl: IRHMADesktop,
					mobileImageUrl: IRHMAMobile,
					containerClassName: "-mx-6 md:-mx-9 xl:-mx-14",
				},
			},
			{
				type: "image-grid",
				id: "irhma-images",
				data: {
					cols: 3,
					responsiveCols: {
						xs: 1,
						md: 3,
					},
					items: IRHMAImages,
				},
			},
		],
	},
	"/introduction/products": {
		blocks: [
			{
				type: "text",
				id: "introduction-products-intro",
				data: {
					text: "APPLiA represents the home appliance sector in Europe. Our members manufacture a wide variety of home appliances which can be categorised into three main groups: home comfort appliances, large home appliances, and small home appliances.",
				},
			},
			{
				type: "responsive-image",
				id: "introduction-products-visual",
				data: {
					desktopImageUrl: ProductsDesktop,
					mobileImageUrl: ProductsMobile,
					imageAlt: "A visual showing the product tree. The first product category is home comfort appliances: air conditioners, air-to-air heat pumps, local space heaters, towel heaters and water heaters. The second product category is Large Home Appliances: dishwashers, freezers, hobs, ovens, range hoods, refrigerators, tumble dryers and washing machines. The third product category is Small Home Appliances: Blenders, coffee machines, irons, juice makers, kettles, kitchen robots, microwaves, mixers, raclette makers, rice cookers, toasters, toothbrushes, vacuum cleaners and waffle makers.",
					containerClassName: "flex flex-col",
					desktopClassName: "max-w-4xl",
				},
			},
		],
	},
	"/introduction/home-appliance-industry": {
		blocks: [
			{
				id: "home-appliance-industry-stats",
				type: "stat-grid",
				data: {
					items: [
						{
							id: "industry-stat-gdp",
							iconUrl: IconEuros,
							value: "€<span data-count-to='80'>80</span> bn",
							after: "in value added to Europe's GDP across over 3.200 companies.",
						},
						{
							id: "industry-stat-jobs",
							iconUrl: IconWorkers,
							before: "The industry supports nearly",
							value: "1 million",
							after: "direct and indirect jobs across Europe.",
						},
						{
							id: "industry-stat-made-in-europe",
							iconUrl: IconEurope,
							before: "Of the large home appliances sold in Europe, over",
							value: "<span data-count-to='70'>70</span>%",
							after: "are made in Europe.",
						},
						{
							id: "industry-stat-manufacturing-sites",
							iconUrl: IconFactory,
							value: "+<span data-count-to='150'>110</span>",
							after: "manufacturing sites throughout Europe.",
						},
						{
							id: "industry-stat-rd-sites",
							iconUrl: IconIdea,
							value: "<span data-count-to='500'>500</span>+",
							after: "total manufacturing and R&D sites anchoring local skills and innovation.",
						},
						{
							id: "industry-stat-rd-investment",
							iconUrl: IconSolution,
							value: "€<span data-count-to='1.6' data-count-decimals='1'>1,6</span> bn",
							after: "invested annually in local innovation and R&D.",
						},
						{
							id: "industry-stat-energy-reduction",
							iconUrl: IconSaveEnergy,
							before: "Energy consumption dropped by roughly",
							value: "<span data-count-to='65'>65</span>%",
							after: "for consumers, thanks to energy-efficient appliances that leave room for further energy savings in a market with more than 200 million households.",
						},
						{
							id: "industry-stat-suppliers",
							iconUrl: IconTrolley,
							before: "Annually, over",
							value: "€<span data-count-to='44'>44</span> bn",
							after: "is spent on European suppliers.",
						},
						{
							id: "industry-stat-consumer-savings",
							iconUrl: IconCustomer,
							before: "Consumers save up to",
							value: "€<span data-count-to='317'>317</span>",
							after: "per year (2024 prices) through more energy-efficient products alone.",
							source: "European Commission",
						},
						{
							id: "industry-stat-efficiency-gain",
							iconUrl: IconBattery,
							value: "30–40%",
							after: "better overall energy efficiency in home appliances since 2000, delivering household energy savings equivalent to 11 million tonnes of oil equivalent between 2000 and 2023.",
							source: "Enerdata",
						},
					],
				},
			},
		],
	},
	"/introduction/executive-summary": {
		blocks: [
			{
				id: "executive-summary-intro",
				type: "text",
				data: {
					text: "Europe’s home appliance industry is a strategic industrial asset for the region's economy, manufacturing base, and sustainable transition. The sector supports nearly <strong>1 million direct and indirect jobs</strong>, contributes close to <strong>€80 billion in value-added to GDP</strong>, and remains deeply embedded in Europe’s industrial ecosystem, <strong>purchasing €44 billion annually from European suppliers</strong> while anchoring key value chains in steel, logistics, and advanced recycling. As detailed in this edition of the Home Appliance Monitor, the sector continues to successfully decouple industrial footprint growth from environmental degradation. On the factory floor, manufacturers have achieved a strict 50% energy reduction alongside an 18% cut in waste generation. This industrial innovation translates directly into benefits for European households. The <strong>widespread adoption of highly energy-efficient appliances</strong> has significantly reduced residential energy consumption. Between 2000 and 2023, the efficiency gains of about 40% from our large household appliances delivered energy savings equivalent to approximately <strong>11 million tonnes of oil equivalent</strong> for European households.",
				},
			},
			{
				id: "executive-summary-image-left",
				type: "text-image",
				data: {
					type: "image-left",
					imageUrl: Policy6,
					imageSize: "normal",
					text: [
						"However, this vital industrial base is operating in an increasingly demanding environment where macroeconomic pressures and structural shifts threaten regional competitiveness. As tracked across our core manufacturing data, the sector has faced a sharp consumer market recalibration, with total product transactions contracting by 1.7% to land at 172.2 million units sold in Europe. This volume drop is occurring alongside a <strong>steady erosion of European Single Market trade autonomy</strong>, evidenced by a 5.1 percentage point drop in intra-European sourcing for large appliances and a €15.326 billion influx of imports from China. Compounding these shifting trade fluxes is a <strong>highly fragmented regulatory and financial landscape</strong>. A single appliance can face at least 10 different regulatory frameworks, while companies complying with these rigorous EU rules face growing competition from low-value, unverified imports. In 2024 alone, <strong>around 4.6 billion low-value consignments entered the EU market</strong>, placing additional pressure on enforcement systems and creating structural risks of non-compliance with safety, ecodesign, and producer responsibility obligations.","Furthermore, Europe's innovation ecosystem remains geographically concentrated. Research and development expenditure across the EU reached €160.9 billion, with investment concentrated in a small number of countries, led by Germany, followed by France and Italy. This concentration has enabled strong technological leadership but also highlights the importance of maintaining innovation capacity across the wider European industrial base.","At the same time, closing the circular economy loop requires greater coordination across the entire value chain. Around 90 million tonnes of electronic equipment remain in European households, limiting the recovery of valuable materials. Although <strong>3.7 million tonnes of secondary raw materials are recovered annually</strong> from collected waste electrical and electronic equipment (WEEE), supporting industries such as automotive manufacturing, higher collection rates, stronger recycling infrastructure, and <strong>clearer shared responsibilities</strong> among manufacturers, consumers, recyclers, and public authorities are all needed to unlock the full circular potential of these resources.",
					],
				},
			},
			{
				id: "executive-summary-image-right",
				type: "text-image",
				data: {
					type: "image-right",
					imageUrl: Policy8,
					imageSize: "normal",
					text: [
						"These developments point to a broader, <strong>systemic competitiveness issue</strong>. If Europe does not address the cumulative pressures affecting downstream manufacturing, it risks permanently weakening its industrial capacity, its investment attractiveness, and its ability to retain cutting-edge innovation within the Single Market. What is at stake is Europe’s ability to align its climate, circular economy, and industrial objectives with a strong, self-sustaining manufacturing base. Preserving this capacity requires effective market enforcement, a level playing field for EU and imported products, greater regulatory coherence, and targeted measures that support industrial continuity.",
					],
				},
			},
			{
				id: "executive-summary-final",
				type: "text",
				data: {
					text: "The Home Appliance Monitor presents both a clear snapshot of the sector today and an urgent forward-looking message: the home appliance industry continues to deliver for households, the economy, and sustainability, but its future contribution will depend entirely on creating the <strong>right conditions</strong> for manufacturing, investment, and innovation within Europe."
				}
			}
		],
	},
};
